export const Prices = [
  {
    title: "Årspris - Standard",
    url: null,
    price: "8400",
    extraInfo: "Grunnpris per år",
  },
  {
    title: "Årspris - Medlem av Virke Aktiv Helse",
    url: "https://www.virke.no/bransjer/trening/",
    price: "3600",
    extraInfo: "Grunnpris per år",
  },
  {
    title: "Årspris - Medlem av NHO Geneo",
    url: "https://www.nhosh.no/bransjer/helse-og-velferd/aktivhelse/aktivhelse/",
    price: "3600",
    extraInfo: "Grunnpris per år",
  },
];

export const MembershipBenifits = [
  "Gyldig sertifikat og klistermerke til ytterdør som viser at det er et Rent Senter",
  "Plakater, brosjyrer, informasjonsmateriell og digitalt innhold",
  "Veileder for antidopingarbeidet",
  "E-læring for ansatte",
  "E-læring for medlemmer",
  "Kurs i «den viktige samtalen»",
  "Samtaleguide og verktøy til gjennomføring av samtaler",
  "Promotering på Antidoping Norges nettsider",
  "Kampanjer fra Antidoping Norge for å promotere Rent Senter",
  "Markedsføringsmateriell dere selv kan benytte",
  "Veiledning og oppfølging ved mistanke om bruk",
];

export const DbsControl = [
  {
    tests: 1,
    perPkg: "7800",
    perTest: "7800",
  },
  {
    tests: 3,
    perPkg: "16500",
    perTest: "5500",
  },
  {
    tests: 6,
    perPkg: "29400",
    perTest: "4900",
  },
  {
    tests: 10,
    perPkg: "45900",
    perTest: "4600",
  },
];

export const UrinControl = [
  {
    tests: 1,
    perPkg: "7900",
    perTest: "7900",
  },
];
